import React from 'react'
import { useMessageStore } from '@/stores/messageStore'
import FloatingMessageBox from '@/components/Message/FloatingMessageBox'

const FloatingMessageDisplay = (): React.ReactElement | null => {
  const message = useMessageStore((s) => s.message)
  const clear = useMessageStore((s) => s.clear)

  if (!message || !message.toast) return null

  return (
    <FloatingMessageBox
      message={message.text}
      type={(message.type ?? undefined) as 'error' | 'success' | 'warning' | 'info' | undefined}
      onClose={clear}
      duration={message.duration ?? undefined}
      icon={message.icon ?? undefined}
    />
  )
}

export default FloatingMessageDisplay
